var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 288c79.53 0 144-64.47 144-144s-64.47-144-144-144c-79.52 0-144 64.47-144 144S176.5 288 256 288zM256 32c61.76 0 112 50.24 112 112C368 205.8 317.8 256 256 256S144 205.8 144 144C144 82.24 194.2 32 256 32zM351.1 320H160c-88.36 0-160 71.63-160 160c0 17.67 14.33 32 31.1 32H480c17.67 0 31.1-14.33 31.1-32C512 391.6 440.4 320 351.1 320zM32 480c0-70.58 57.42-128 128-128h191.1C422.6 352 480 409.4 480 480H32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLarge);
export default __webpack_public_path__ + "static/media/user-large.c1774f81d3b4fe201ffe065bd5b9c454.svg";
export { ForwardRef as ReactComponent };